export default __webpack_public_path__ + "static/media/autogestivo.f286004b.png";